import { NavLink, Outlet } from 'react-router-dom';
import { FiUser, FiPackage, FiGift } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import './Account.css';

function initials(name, phone) {
  const n = String(name || '').trim();
  if (n) {
    const parts = n.split(/\s+/).filter(Boolean);
    return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || 'LS';
  }
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.slice(-2) || 'LS';
}

export default function AccountLayout() {
  const { user } = useAuth();
  const title = user?.name || 'Профиль';
  const phone = user?.phone || '';

  return (
    <div className="account">
      <div className="account__inner container">
        <header className="account-hero">
          <div className="account-hero__avatar" aria-hidden>
            {initials(user?.name, phone)}
          </div>
          <div className="account-hero__text">
            <p className="account-hero__kicker">LavSan Store</p>
            <h1 className="account-hero__title">Личный кабинет</h1>
            <p className="account-hero__sub">
              {title}
              {phone ? ` · ${phone}` : ''}
            </p>
          </div>
        </header>

        <nav className="account-nav" aria-label="Навигация по кабинету">
          <NavLink
            to="/account/orders"
            className={({ isActive }) => `account-nav__link${isActive ? ' is-active' : ''}`}
          >
            <FiPackage />
            <span>Заказы</span>
          </NavLink>
          <NavLink
            to="/account/bonuses"
            className={({ isActive }) => `account-nav__link${isActive ? ' is-active' : ''}`}
          >
            <FiGift />
            <span>Бонусы</span>
          </NavLink>
          <NavLink
            to="/account/profile"
            className={({ isActive }) => `account-nav__link${isActive ? ' is-active' : ''}`}
          >
            <FiUser />
            <span>Профиль</span>
          </NavLink>
        </nav>

        <main className="account-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
